import './styles.scss'
import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'

import { Button } from 'components/Form'

const ActionButtons = ({ alternative, alternativesButtonsActive, setAlternativesButtonsActive, toggleActionModal }) => {
  const [isButtonsDisabled, setIsButtonsDisabled] = useState(false)

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (!alternative.alternativeActions.onProcess[0].actionList.length) return setIsButtonsDisabled(false)

      for (const action of alternative.alternativeActions.onProcess[0].actionList) {
        if (!action.botActionList.length) {
          return setIsButtonsDisabled(true)
        } else {
          setIsButtonsDisabled(false)
        }
      }
    }

    return () => isSubscribed = false
  }, [alternative])

  return (
    <div className='smartchat-action-buttons animated fadeIn'>
      <div className='add-action'>
        <button
          type='button'
          className='add-action-button animated fadeIn'
          onClick={() => setAlternativesButtonsActive(alternative.id)}
          hidden={alternativesButtonsActive === alternative.id ? true : false}
        >
          <i className='fa fa-plus-circle' />
          <span>{I18n.t('dashboard_add-action')}</span>
        </button >
        <div className='add-all-button' hidden={alternativesButtonsActive === alternative.id ? false : true}>
          {(alternative.alternativeActions.onNewProcess.actionList.length > 0 || alternative.alternativeActions.onProcess[0].actionList.length > 0) && (
            <Button
              className='btn animated fadeIn'
              container
              containerPrimary
              value={I18n.t('chatbot_button_customerAction')}
              onClick={() => toggleActionModal({
                mode: 'add',
                actionType: 'customerAction',
                containerType: 'onProcess',
                alternativeId: alternative.id
              })}
              disabled={isButtonsDisabled}
            />
          )}
          <Button
            className='btn animated fadeIn'
            container
            containerPrimary
            value={I18n.t('chatbot_button_botAction')}
            onClick={() => toggleActionModal({
              mode: 'add',
              actionType: 'botAction',
              containerType: alternative.alternativeActions.onProcess[0].actionList.length
                ? 'onProcess'
                : 'onNewProcess',
              fromActionType: alternative.alternativeActions.onProcess[0].actionList.length
                ? alternative.alternativeActions.onProcess[0].actionList[alternative.alternativeActions.onProcess[0].actionList.length - 1].actionType
                : null,
              fromAction: alternative.alternativeActions.onProcess[0].actionList.length
                ? alternative.alternativeActions.onProcess[0].actionList[alternative.alternativeActions.onProcess[0].actionList.length - 1].actionSubtype
                : null,
              fromActionIndex: alternative.alternativeActions.onProcess[0].actionList.length
                ? alternative.alternativeActions.onProcess[0].actionList.length - 1
                : null,
              alternativeId: alternative.id
            })}
          />
          {(alternative.alternativeActions.onNewProcess.actionList.length > 0 || alternative.alternativeActions.onProcess[0].actionList.length > 0) && (
            <Button
              className='btn animated fadeIn'
              container
              containerPrimary
              value={I18n.t('chatbot_button_operatorAction')}
              onClick={() => toggleActionModal({
                mode: 'add',
                actionType: 'operatorAction',
                containerType: 'onProcess',
                alternativeId: alternative.id
              })}
              disabled={isButtonsDisabled}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ActionButtons
